import React, { useContext, useEffect, useRef, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import axios from "axios";
import * as Yup from "yup";
import { APIURL } from "../../../Config";
import { Modal, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import SweetAlert from "react-bootstrap-sweetalert";
import ManageEmploye from "./ManageEmploye";
import { useNavigate } from "react-router-dom";
import { useAppContext } from "../../utils/Appcontex";
import moment from "moment";

function Profile({ props }) {
  const emailid = localStorage.getItem("emailId");
  const workspaceId = localStorage.getItem("workspace");
  const token = localStorage.getItem("token");
  const [workSpace, setWorkSpace] = useState([]);
  const [isLoader, setIsLoader] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showAgreementModal, setShowAgreementModal] = useState(false);
  const [showYes, setShowYes] = useState(true);
  const [showNo, setShowNo] = useState(false);
  const [address, setAddress] = useState("");
  const [website, setWebsite] = useState("");
  const [alert, setAlert] = useState(null);
  const [isChecked, setIsChecked] = useState(true);
  const [tncSign, setTncSign] = useState(false);
  const [showOtp, setShowOtp] = useState(false);
  const history = useNavigate();
  const { open, setOpen, setKey, setActiveIndex } = useAppContext();
  const [otp, setOtp] = useState(new Array(6).fill(""));
  const otpBoxReference = useRef([]);
  const [modelValue, setModelValue] = useState("yes");
  const [todayDate, setTodayDate] = useState("");
  const [location, setLocation] = useState({
    latitude: null,
    longitude: null,
  });
  console.log("location::: ", location);
  const [deviceID, setDeviceID] = useState(null);
  console.log("deviceID::: ", deviceID);

  const getLocation = (setLocation) => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          console.log(latitude);
          setLocation({ latitude, longitude });
        },
        (error) => {
          console.error("Error obtaining location:", error);
        }
      );
    } else {
      console.error("Geolocation is not supported by this browser.");
    }
  };

  const generateDeviceID = () => {
    let deviceID = localStorage.getItem("deviceID");
    if (!deviceID) {
      deviceID = `device-${Math.random().toString(36).substr(2, 9)}`;
      localStorage.setItem("deviceID", deviceID);
    }
    return deviceID;
  };

  useEffect(() => {
    getLocation(setLocation);
    const id = generateDeviceID();
    setDeviceID(id);
  }, []);
  useEffect(() => {
    getLocation(setLocation);
    const id = generateDeviceID();
    setDeviceID(id);
  }, []);

  console.log("todayDate", todayDate, workSpace?.model);

  function WorkspaceDetails() {
    const data = { emailid, workspaceId };
    setIsLoader(true);
    axios
      .request(`${APIURL}/corporate/getprofiledetails`, {
        method: "POST",
        data: data,
        headers: {
          Authentication: token,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("response:::::::", response);
        setIsLoader(false);
        setWorkSpace({ ...response?.data });
        // setWorkSpace(response?.data);
        if (response.data.model === "no") {
          setShowYes(false);
          setShowNo(true);
          setModelValue("no");
        } else {
          setShowYes(true);
          setShowNo(false);
          setModelValue("yes");
        }
        if (response.data?.assuranceTc) {
          setTncSign(true);
        }
      })
      .catch((error) => {
        setIsLoader(false);
        console.log(error);
      });
  }

  useEffect(() => {
    if (token && emailid) {
      WorkspaceDetails();
      const date = new Date();
      setTodayDate(date);
    }
  }, [token, emailid]);
  const NoSchema = Yup.object().shape({
    // paymentmode: Yup.string().required("Please select a user type"),
    model: Yup.string().required("Please select an option"),
    address: Yup.string()
      .required("Address is required")
      .test(
        "no-empty-spaces",
        "Spaces not allowed",
        (value) => value && value.trim().length > 0
      ),
    // companyType: Yup.string().required("Please select an option"),
    charges: Yup.string().required("Please check"),
  });
  const YesSchema = Yup.object().shape({
    // paymentmode: Yup.string().required("Please select a user type"),
    model: Yup.string().required("Please select an option"),
    address: Yup.string()
      .required("Address is required")
      .test(
        "no-empty-spaces",
        "Spaces not allowed",
        (value) => value && value.trim().length > 0
      ),
    // companyType: Yup.string().required("Please select an option"),
    charges: Yup.string().required("Please check"),
    // hrApp: Yup.string().required("Please select an option"),
    // fundEmployees: Yup.string().required("Please select an option"),
  });
  const handleRadioChange = (setFieldValue, value) => {
    setModelValue(value);
    setFieldValue("model", value);
    if (value === "no") {
      setShowModal(true);
      setShowYes(false);
    } else if (value === "Yes") {
      setShowYes(true);
      setShowNo(false);
    }
  };

  const handleModalChange = (value, setFieldValue) => {
    if (value === "yes") {
      setShowYes(true);
      setShowNo(false);
      setShowModal(false);
      setFieldValue("model", "Yes");
    } else if (value === "no") {
      setShowNo(true);
      setShowYes(false);
      setShowModal(false);
      setFieldValue("model", "no");
    }
  };
  const [progress, setProgress] = useState(0);
  console.log("worksapcE:::", workSpace);
  const initialValues = {
    corpadminmail: workSpace?.corpadminmail || "",
    paymentmode: workSpace?.paymentmode || "",
    companyName: workSpace ? workSpace?.companyName : "",
    empname: workSpace?.empname ? workSpace?.empname : "",
    mobile: workSpace ? workSpace?.mobile : "",
    numberofemployees: workSpace?.numberofemployees || "",
    model: workSpace?.model || "yes",
    address: workSpace?.address || "",
    companyType: workSpace?.companyType || "",
    charges:
      workSpace?.companyType !== null
        ? workSpace?.charges || "ok"
        : workSpace?.charges || "ok",

    hrApp: workSpace?.hrApp || "no",
    fundEmployees: workSpace?.fundEmployees || "no",
    website: workSpace?.website || "",
  };

  const calculateProgress = (values) => {
    let filledFields = 0;
    const fields = Object.keys(values);
    fields.forEach((field) => {
      if (values[field]) {
        filledFields++;
      }
    });
    const progress = (filledFields / fields.length) * 100;
    return progress > 100 ? 100 : progress;
  };

  const PopUp = () => {
    setAlert(
      <SweetAlert
        success
        style={{ display: "block" }}
        onConfirm={() => {
          setAlert(null);
          setKey("ManageEmployees");
          setActiveIndex(5);
          setOpen(true);
        }}
        confirmBtnStyle={{ backgroundColor: "#66a725", border: "none" }}
      >
        <h6>Congratulations, your workspace has been successfully set up.</h6>
        <h6>
          While we finalize the backend, please proceed to upload your employee
          data. We will notify you as soon as the backend is finalised.
        </h6>
      </SweetAlert>
    );
  };

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };
  const handleClose = () => {
    setIsChecked(false);
    setShowAgreementModal(false);
    setShowOtp(false);
  };

  const handleSubmit = () => {
    console.log("isChecked::: ", isChecked);
    if (isChecked) {
      setIsLoading(true);
      axios
        .request(`${APIURL}/sendOTPtc/${workSpace?.email}`, {
          method: "GET",
        })
        .then((response) => {
          console.log("response", response);
          setIsLoading(false);
          if (response) {
            toast.success("OTP sent successfully");
            setIsChecked(false);
            setShowOtp(true);
          }
        })
        .catch((error) => {
          console.log("error", error);
          setIsLoading(false);
        });
    } else {
      toast.warning("Please check the box before submitting.");
    }
  };

  function handleChange(value, index) {
    let newArr = [...otp];
    newArr[index] = value;
    setOtp(newArr);

    if (value && index < 5) {
      otpBoxReference.current[index + 1].focus();
    }
  }
  function handleBackspaceAndEnter(e, index) {
    if (e.key === "Backspace" && !e.target.value && index > 0) {
      otpBoxReference.current[index - 1].focus();
    }
    if (e.key === "Enter" && e.target.value && index < 5) {
      otpBoxReference.current[index + 1].focus();
    }
  }

  return (
    <>
      {!open ? (
        <div className="p-md-3 pt-3">
          {isLoader ? (
            <div className="d-flex justify-content-center mt-5">
              <div className="spinner-border text-success" role="status"></div>
            </div>
          ) : (
            <>
              {alert}
              <div className="card">
                <div className="p-4">
                  {console.log("intial values:::", initialValues)}
                  {workSpace && (
                    <Formik
                      initialValues={initialValues}
                      validationSchema={showNo ? NoSchema : YesSchema}
                      onSubmit={(values) => {
                        // if (modelValue == "yes") {
                        //   if (!tncSign) {
                        //     return toast.error("Assurance agreement");
                        //   }
                        // }
                        console.log("values", values);
                        setIsLoader(true);
                        axios
                          .request(`${APIURL}/corporate/completeprofile`, {
                            method: "POST",
                            data: { ...values, ownerEmail: emailid },
                            headers: {
                              "Content-Type": "application/json",
                              Authentication: token,
                            },
                          })
                          .then((response) => {
                            console.log("response", response);
                            setIsLoader(false);
                            toast.success(response?.data?.message);
                            PopUp();
                            WorkspaceDetails();
                            window.location.reload();
                          })
                          .catch((error) => {
                            console.log("error", error);
                            setIsLoader(false);
                            toast.warning("User does not exist...");
                          });
                      }}
                    >
                      {({
                        touched,
                        errors,
                        setFieldValue,
                        values,
                        handleChange,
                      }) => (
                        <>
                          <Form className="">
                            <div>
                              <div>
                                <h4
                                  className="py-2 text-center"
                                  style={{ color: "#66a725", fontWeight: 800 }}
                                >
                                  Profile
                                </h4>
                                <div className="">
                                  <label>Work Email*</label>
                                  <Field
                                    type="email"
                                    name="corpadminmail"
                                    placeholder="Enter company email"
                                    className={`form-control
                          ${
                            touched.corpadminmail && errors.corpadminmail
                              ? "is-invalid"
                              : ""
                          }`}
                                    disabled
                                  />
                                  <ErrorMessage
                                    component="div"
                                    name="corpadminmail"
                                    className="invalid-feedback"
                                  />
                                </div>

                                <div className="mt-2">
                                  <label>Employer Name*</label>
                                  <Field
                                    type="text"
                                    name="companyName"
                                    placeholder="Enter company name"
                                    className={`form-control
                          ${
                            touched.companyName && errors.companyName
                              ? "is-invalid"
                              : ""
                          }`}
                                    disabled
                                  />
                                  <ErrorMessage
                                    component="div"
                                    name="companyName"
                                    className="invalid-feedback"
                                  />
                                </div>
                                <div className="mt-2">
                                  <label>Your Name*</label>
                                  <Field
                                    type="text"
                                    name="empname"
                                    placeholder="Enter name"
                                    className={`form-control
                          ${
                            touched.empname && errors.empname
                              ? "is-invalid"
                              : ""
                          }`}
                                    disabled
                                  />
                                  <ErrorMessage
                                    component="div"
                                    name="empname"
                                    className="invalid-feedback"
                                  />
                                </div>

                                <div className="mt-2">
                                  <label>Mobile No*</label>
                                  <Field
                                    type="number"
                                    name="mobile"
                                    placeholder="Enter mobile no"
                                    className={`form-control
                          ${
                            touched.mobile && errors.mobile ? "is-invalid" : ""
                          }`}
                                    disabled
                                  />
                                  <ErrorMessage
                                    component="div"
                                    name="mobile"
                                    className="invalid-feedback"
                                  />
                                </div>
                                <div className="mt-2">
                                  <label>No. of employees*</label>
                                  <Field
                                    type="number"
                                    name="numberofemployees"
                                    placeholder="Enter number of employees"
                                    className={`form-control
                          ${
                            touched.numberofemployees &&
                            errors.numberofemployees
                              ? "is-invalid"
                              : ""
                          }`}
                                    disabled
                                  />

                                  <ErrorMessage
                                    component="div"
                                    name="numberofemployees"
                                    className="invalid-feedback"
                                  />
                                </div>
                                {/* //payment mode */}
                                {/* <div className="mt-3">
                                  <label>Payment Mode*</label>
                                  <div className=" mb-2">
                                    <div className="form-check">
                                      <Field
                                        type="radio"
                                        name="paymentmode"
                                        value="Employer"
                                        className={`form-check-input border-3 ${
                                          touched.paymentmode &&
                                          errors.paymentmode
                                            ? "is-invalid"
                                            : ""
                                        }`}
                                        onChange={() =>
                                          setFieldValue(
                                            "paymentmode",
                                            "Employer"
                                          )
                                        }
                                      />
                                      <div>
                                        <label className="form-check-label">
                                          I would like to deduct the outstanding
                                          balance of the Salary Advance directly
                                          from the payroll at the end of the
                                          month.
                                        </label>
                                      </div>
                                    </div>
                                    <div className="form-check mt-2">
                                      <Field
                                        type="radio"
                                        name="paymentmode"
                                        value="Employee"
                                        className={`form-check-input border-3 ${
                                          touched.paymentmode &&
                                          errors.paymentmode
                                            ? "is-invalid"
                                            : ""
                                        }`}
                                        onChange={() =>
                                          setFieldValue(
                                            "paymentmode",
                                            "Employee"
                                          )
                                        }
                                      />
                                      <div>
                                        <label className="form-check-label">
                                          I would prefer my employees to settle
                                          their outstanding Salary Advance
                                          balance themselves after receiving
                                          their salary at the end of the month.
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <ErrorMessage
                                    component="div"
                                    name="paymentmode"
                                    className="invalid-feedback"
                                  />
                                </div> */}
                                {/* <div className="form-group mt-2">
                                  <label>
                                    I am willing to assure repayment of my
                                    employee if the employee does not pay by the
                                    7th of the next month? *
                                  </label>
                                  <div className="d-flex">
                                    <div className="form-check">
                                      <Field
                                        type="radio"
                                        name="model"
                                        value="Yes"
                                        className={`form-check-input border-3 ${
                                          touched.model && errors.model
                                            ? "is-invalid"
                                            : ""
                                        }`}
                                        disabled={workSpace?.model !== null}
                                        onChange={() =>
                                          handleRadioChange(
                                            setFieldValue,
                                            "Yes"
                                          )
                                        }
                                      />
                                      <div>
                                        <label className="form-check-label">
                                          Yes
                                        </label>
                                      </div>
                                    </div>
                                    <div className="form-check ml-4">
                                      <Field
                                        type="radio"
                                        name="model"
                                        value="no"
                                        className={`form-check-input border-3 ${
                                          touched.model && errors.model
                                            ? "is-invalid"
                                            : ""
                                        }`}
                                        disabled={workSpace?.model !== null}
                                        onChange={() =>
                                          handleRadioChange(setFieldValue, "no")
                                        }
                                      />
                                      <div>
                                        <label className="form-check-label">
                                          No
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <ErrorMessage
                                    component="div"
                                    name="check"
                                    className="invalid-feedback"
                                  />
                                </div> */}
                                <Modal
                                  show={showModal}
                                  onHide={() => setShowModal(false)}
                                  centered
                                  size="lg"
                                  style={{ background: "#ffffffd1" }}
                                >
                                  <Modal.Body closeButton>
                                    <p className="px-2 py-2">
                                      We would like you to reconsider assuring
                                      employee repayment, as failing to do so
                                      will require us to conduct a thorough
                                      credit assessment of the employee. This
                                      could result in many rejections and
                                      reduced credit limits, thereby limiting
                                      the benefits of the on-demand salary
                                      feature for employees. Would you like to
                                      reconsider Assuring repayment for your own
                                      employees. I confirm that I will Assure
                                      repayment of my employees.
                                    </p>
                                  </Modal.Body>
                                  <Modal.Footer className="d-flex justify-content-start">
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                      className="px-2"
                                    >
                                      <div className="form-check">
                                        <input
                                          className="form-check-input border-3"
                                          type="radio"
                                          name="modalCheck"
                                          onClick={() =>
                                            handleModalChange(
                                              "yes",
                                              setFieldValue
                                            )
                                          }
                                        />
                                        <label className="form-check-label">
                                          Yes
                                        </label>
                                      </div>
                                      <div className="form-check ml-2">
                                        <input
                                          className="form-check-input border-3"
                                          type="radio"
                                          name="modalCheck"
                                          onClick={() =>
                                            handleModalChange(
                                              "no",
                                              setFieldValue
                                            )
                                          }
                                        />
                                        <label className="form-check-label">
                                          No
                                        </label>
                                      </div>
                                    </div>
                                  </Modal.Footer>
                                </Modal>
                                {showYes && (
                                  <>
                                    <div className="mt-2">
                                      <label>Address*</label>
                                      <Field
                                        type="text"
                                        name="address"
                                        placeholder="Enter address"
                                        className={`form-control
                          ${
                            touched.address && errors.address
                              ? "is-invalid"
                              : ""
                          }`}
                                        disabled={workSpace?.address !== null}
                                        onChange={(e) => {
                                          handleChange(e);
                                          setAddress(e.target.value);
                                        }}
                                      />
                                      <ErrorMessage
                                        component="div"
                                        name="address"
                                        className="invalid-feedback"
                                      />
                                    </div>
                                    {/* <div className="form-group mt-2">
                                      <label>Company type*</label>
                                      <div
                                        className="d-flex"
                                        style={{ flexDirection: "column" }}
                                      >
                                        <div className="form-check">
                                          <Field
                                            type="radio"
                                            name="companyType"
                                            value="Listed on Stock Exchange"
                                            className={`form-check-input border-3 ${
                                              touched.companyType &&
                                              errors.companyType
                                                ? "is-invalid"
                                                : ""
                                            }`}
                                            onChange={(e) => {
                                              handleChange(e);
                                              setProgress(
                                                calculateProgress(values)
                                              );
                                            }}
                                            disabled={
                                              workSpace?.companyType !== null
                                            }
                                          />
                                          <div>
                                            <label className="form-check-label">
                                              Listed on Stock Exchange
                                            </label>
                                          </div>
                                        </div> */}
                                    {/* <div className="form-check mt-2">
                                          <Field
                                            type="radio"
                                            name="companyType"
                                            value="Not listed but have a website"
                                            className={`form-check-input border-3 ${
                                              touched.companyType &&
                                              errors.companyType
                                                ? "is-invalid"
                                                : ""
                                            }`}
                                            disabled={
                                              workSpace?.companyType !== null
                                            }
                                            onChange={(e) => {
                                              handleChange(e);
                                              setProgress(
                                                calculateProgress(values)
                                              );
                                            }}
                                          />
                                          <div>
                                            <label className="form-check-label">
                                              Not listed but have a website
                                            </label>
                                          </div>
                                        </div> */}
                                    {/* <div className="form-check mt-2">
                                          <Field
                                            type="radio"
                                            name="companyType"
                                            value="Not listed and no website"
                                            className={`form-check-input border-3 ${
                                              touched.companyType &&
                                              errors.companyType
                                                ? "is-invalid"
                                                : ""
                                            }`}
                                            disabled={
                                              workSpace?.companyType !== null
                                            }
                                            onChange={(e) => {
                                              handleChange(e);
                                              setProgress(
                                                calculateProgress(values)
                                              );
                                            }}
                                          />
                                          <div>
                                            <label className="form-check-label">
                                              Not listed and no website
                                            </label>
                                          </div>
                                        </div> */}
                                    {/* </div>
                                      <ErrorMessage
                                        component="div"
                                        name="check"
                                        className="invalid-feedback"
                                      />
                                    </div> */}

                                    {/* <div className="mt-2">
                                      <label>Website (if available)</label>
                                      <Field
                                        type="text"
                                        name="website"
                                        placeholder="Enter website url"
                                        className={`form-control
                          ${
                            touched.website && errors.website
                              ? "is-invalid"
                              : ""
                          }`}
                                        disabled={workSpace?.website !== null}
                                        onChange={(e) => {
                                          handleChange(e);
                                          setWebsite(e.target.value);
                                        }}
                                      />
                                      <ErrorMessage
                                        component="div"
                                        name="website"
                                        className="invalid-feedback"
                                      />
                                    </div> */}

                                    {/* <div className="form-group mt-2">
                                      <label>
                                        I would like to customise Salarytap in
                                        my HR app*
                                      </label>
                                      <div className="d-flex">
                                        <div className="form-check ">
                                          <Field
                                            type="radio"
                                            name="hrApp"
                                            value="no"
                                            className={`form-check-input border-3 ${
                                              touched.hrApp && errors.hrApp
                                                ? "is-invalid"
                                                : ""
                                            }`}
                                            disabled={workSpace?.hrApp !== null}
                                            onChange={(e) => {
                                              handleChange(e);
                                              setProgress(
                                                calculateProgress(values)
                                              );
                                            }}
                                          />
                                          <div>
                                            <label className="form-check-label">
                                              No
                                            </label>
                                          </div>
                                        </div>
                                        <div className="form-check ml-3">
                                          <Field
                                            type="radio"
                                            name="hrApp"
                                            value="yes"
                                            className={`form-check-input border-3 ${
                                              touched.hrApp && errors.hrApp
                                                ? "is-invalid"
                                                : ""
                                            }`}
                                            disabled={workSpace?.hrApp !== null}
                                            onChange={(e) => {
                                              handleChange(e);
                                              setProgress(
                                                calculateProgress(values)
                                              );
                                            }}
                                          />
                                          <div>
                                            <label className="form-check-label">
                                              Yes
                                            </label>
                                          </div>
                                        </div>
                                      </div>

                                      <ErrorMessage
                                        component="div"
                                        name="hrApp"
                                        className="invalid-feedback"
                                        render={(msg) => <div>{msg}</div>}
                                      />
                                    </div> */}
                                    {/* <div className="form-group mt-2">
                                      <label>
                                        I would like to use my own funds to fund
                                        my employees
                                      </label>
                                      <div className="d-flex">
                                        <div className="form-check">
                                          <Field
                                            type="radio"
                                            name="fundEmployees"
                                            value="no"
                                            className={`form-check-input border-3 ${
                                              touched.fundEmployees &&
                                              errors.fundEmployees
                                                ? "is-invalid"
                                                : ""
                                            }`}
                                            disabled={
                                              workSpace?.fundEmployees !== null
                                            }
                                            onChange={(e) => {
                                              handleChange(e);
                                              setProgress(
                                                calculateProgress(values)
                                              );
                                            }}
                                          />
                                          <div>
                                            <label className="form-check-label">
                                              No
                                            </label>
                                          </div>
                                        </div>
                                        <div className="form-check ml-3">
                                          <Field
                                            type="radio"
                                            name="fundEmployees"
                                            value="yes"
                                            className={`form-check-input border-3 ${
                                              touched.fundEmployees &&
                                              errors.fundEmployees
                                                ? "is-invalid"
                                                : ""
                                            }`}
                                            disabled={
                                              workSpace?.fundEmployees !== null
                                            }
                                            onChange={(e) => {
                                              handleChange(e);
                                              setProgress(
                                                calculateProgress(values)
                                              );
                                            }}
                                          />
                                          <div>
                                            <label className="form-check-label">
                                              Yes
                                            </label>
                                          </div>
                                        </div>
                                      </div>

                                      <ErrorMessage
                                        component="div"
                                        name="check"
                                        className="invalid-feedback"
                                      />
                                    </div> */}
                                    {/* {workSpace.status == "Approved" && (
                                      <div className="mt-2">
                                        <label>
                                          {`There are no charges for the Employer.
                                        Employees will incur a ${
                                          workSpace?.gst || 0
                                        }% upwards
                                        convenience fee (determined by risk
                                        criteria) on each withdrawal, along with
                                        a one-time setup fee of Rs.${100} on the
                                        first withdrawal.`}
                                        </label>
                                        <div className="form-check">
                                          <Field
                                            type="radio"
                                            name="charges"
                                            value="ok"
                                            className={`form-check-input border-3 ${
                                              touched.charges && errors.charges
                                                ? "is-invalid"
                                                : ""
                                            }`}
                                            disabled={
                                              workSpace?.companyType !== null
                                            }
                                          />
                                          <div>
                                            <label className="form-check-label">
                                              OK
                                            </label>
                                          </div>
                                        </div>
                                        <ErrorMessage
                                          component="div"
                                          name="charges"
                                          className="invalid-feedback"
                                        />
                                      </div>
                                    )} */}
                                    {!tncSign && (
                                      <div className="mt-2">
                                        <label>
                                          <button
                                            type="button"
                                            className="btn btn-primary"
                                            style={{
                                              textDecoration: "underline",
                                              cursor: "pointer",
                                            }}
                                            onClick={() => {
                                              if (!workSpace?.assuranceTc) {
                                                setShowAgreementModal(true);
                                              }
                                            }}
                                          >
                                            Sign Assurance Agreement
                                          </button>
                                        </label>
                                      </div>
                                    )}
                                  </>
                                )}
                                {showNo && (
                                  <>
                                    <div className="mt-2">
                                      <label>Address*</label>
                                      <Field
                                        type="text"
                                        name="address"
                                        placeholder="Enter address"
                                        className={`form-control
                          ${
                            touched.address && errors.address
                              ? "is-invalid"
                              : ""
                          }`}
                                        disabled={workSpace?.address !== null}
                                      />
                                      <ErrorMessage
                                        component="div"
                                        name="address"
                                        className="invalid-feedback"
                                      />
                                    </div>
                                    {/* <div className="form-group mt-2">
                                      <label>Company type*</label>
                                      <div
                                        className="d-flex"
                                        style={{ flexDirection: "column" }}
                                      >
                                        <div className="form-check">
                                          <Field
                                            type="radio"
                                            name="companyType"
                                            value="listedonStockExchange"
                                            disabled={
                                              workSpace?.companyType !== null
                                            }
                                            className={`form-check-input border-3 ${
                                              touched.companyType &&
                                              errors.companyType
                                                ? "is-invalid"
                                                : ""
                                            }`}
                                          />
                                          <div>
                                            <label className="form-check-label">
                                              Listed on Stock Exchange
                                            </label>
                                          </div>
                                        </div>
                                        <div className="form-check">
                                          <Field
                                            type="radio"
                                            name="companyType"
                                            value="notlistedbuthaveawebsite"
                                            className={`form-check-input border-3 ${
                                              touched.companyType &&
                                              errors.companyType
                                                ? "is-invalid"
                                                : ""
                                            }`}
                                            disabled={
                                              workSpace?.companyType !== null
                                            }
                                          />
                                          <div>
                                            <label className="form-check-label">
                                              Not listed but have a website
                                            </label>
                                          </div>
                                        </div>
                                        <div className="form-check">
                                          <Field
                                            type="radio"
                                            name="companyType"
                                            value="notlistedandnowebsite"
                                            className={`form-check-input border-3 ${
                                              touched.companyType &&
                                              errors.companyType
                                                ? "is-invalid"
                                                : ""
                                            }`}
                                            // disabled={
                                            //   workSpace?.companyType !== null
                                            // }
                                          />
                                          <div>
                                            <label className="form-check-label">
                                              Not listed and no website
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                      <ErrorMessage
                                        component="div"
                                        name="check"
                                        className="invalid-feedback"
                                      />
                                    </div> */}
                                    {/* <div className="mt-2">
                                      <label>
                                        There are no charges for the Employer.
                                        Employees will incur a 1.5% upwards
                                        convenience fee (determined by risk
                                        criteria) on each withdrawal, along with
                                        a one-time setup fee of Rs.300 on the
                                        first withdrawal.
                                      </label>
                                      <div className="form-check">
                                        <Field
                                          type="radio"
                                          name="charges"
                                          value="ok"
                                          className={`form-check-input border-3 ${
                                            touched.charges && errors.charges
                                              ? "is-invalid"
                                              : ""
                                          }`}
                                          // disabled={
                                          //   workSpace?.companyType !== null
                                          // }
                                        />
                                        <div>
                                          <label className="form-check-label">
                                            OK
                                          </label>
                                        </div>
                                      </div>
                                      <ErrorMessage
                                        component="div"
                                        name="charges"
                                        className="invalid-feedback"
                                      />
                                    </div> */}
                                  </>
                                )}

                                <button
                                  className="btn btn-success mt-3 border"
                                  type="submit"
                                  style={{
                                    background: "#66a725",
                                    color: "#fff",
                                    display:
                                      workSpace?.assuranceTc &&
                                      // workSpace?.companyType !== null &&
                                      // workSpace?.hrApp !== null &&
                                      workSpace?.fundEmployees !== null
                                        ? "none"
                                        : "block",
                                  }}
                                >
                                  {isLoader ? (
                                    <div
                                      className="spinner-border text-success"
                                      role="status"
                                    >
                                      <span className="sr-only">
                                        Loading...
                                      </span>
                                    </div>
                                  ) : (
                                    "Submit"
                                  )}
                                </button>
                              </div>
                            </div>
                          </Form>
                        </>
                      )}
                    </Formik>
                  )}
                </div>
              </div>
              <div style={{ width: "80%", height: "100%" }}>
                <Modal
                  show={showAgreementModal}
                  onHide={handleClose}
                  size="lg"
                  style={{ background: "#ffffffd1" }}
                >
                  <div className="px-3">
                    <Modal.Header closeButton>
                      <Modal.Title style={{ color: "#66a725" }}>
                        Assurance Agreement
                      </Modal.Title>
                    </Modal.Header>
                  </div>
                  <Modal.Body>
                    <div className="px-3">
                      <h3
                        className="mt-2"
                        style={{ fontSize: "18px", fontWeight: "700" }}
                      >
                        TRIPARTITE ASSURANCE AGREEMENT
                      </h3>
                      <h3
                        className="mt-2"
                        style={{ fontSize: "18px", fontWeight: "700" }}
                      >
                        This Tripartite Assurance Agreement ("Agreement") is
                        made on this {moment(todayDate).format("DD")} day of{" "}
                        {moment(todayDate).format("MMMM")},{" "}
                        {moment(todayDate).format("YYYY")} by and among:
                      </h3>

                      <h6
                        className="mt-3"
                        style={{ fontWeight: "400", fontSize: "16px" }}
                      >
                        Ontap Technologies Pvt. Limited (Ontap), a company
                        incorporated under the laws of India, having its
                        registered office at Khasra No. 850, Village Bhati
                        Khurd, New Delhi – 110074 (hereinafter referred to as
                        "Ontap", which expression shall, unless repugnant to the
                        context or meaning thereof, be deemed to include its
                        successors and assigns),
                      </h6>

                      <h6
                        className="mt-3"
                        style={{ fontWeight: "400", fontSize: "16px" }}
                      >
                        {workSpace?.companyName}, a company/firm
                        incorporated/registered under the laws of India, having
                        its registered office at {workSpace?.address || address}{" "}
                        (hereinafter referred to as the "Business Owner", which
                        expression shall, unless repugnant to the context or
                        meaning thereof, be deemed to include its successors and
                        assigns), and
                      </h6>

                      <h6
                        className="mt-3"
                        style={{ fontWeight: "400", fontSize: "16px" }}
                      >
                        Capital Trust Limited (CTL), a company incorporated
                        under the laws of India and an RBI-registered NBFC,
                        having its registered office at 205 Centrum Mall,
                        Mehrauli-Gurgaon Road, Sultanpur, New Delhi – 110030
                        (hereinafter referred to as the "Funder", which
                        expression shall, unless repugnant to the context or
                        meaning thereof, be deemed to include its successors and
                        assigns).
                      </h6>

                      <h6
                        className="mt-3"
                        style={{ fontWeight: "400", fontSize: "16px" }}
                      >
                        (Each a "Party" and collectively the "Parties")
                      </h6>

                      <h5
                        className="mt-3"
                        style={{ fontSize: "18px", fontWeight: "500" }}
                      >
                        WHEREAS:
                      </h5>

                      <h6
                        className="mt-3"
                        style={{ fontWeight: "400", fontSize: "16px" }}
                      >
                        A. Ontap operates a technology platform known as
                        CashOnTap, which facilitates Digital credit line
                        services for business associates via partnerships with
                        business owners and NBFCs.
                      </h6>

                      <h6
                        className="mt-3"
                        style={{ fontWeight: "400", fontSize: "16px" }}
                      >
                        B. The Funder extends financial credit to associates of
                        the business owner through the CashOnTap platform for
                        credit line disbursements, under pre-agreed terms.
                      </h6>

                      <h6
                        className="mt-3"
                        style={{ fontWeight: "400", fontSize: "16px" }}
                      >
                        C. The business owner desires to partner with Ontap and
                        the Funder to facilitate credit line access for its
                        associates.
                      </h6>

                      <h3
                        className="mt-4"
                        style={{ fontSize: "19px", fontWeight: "700" }}
                      >
                        NOW, THEREFORE, in consideration of the mutual covenants
                        and promises set forth herein, the Parties agree as
                        follows:
                      </h3>

                      <h5
                        className="mt-4"
                        style={{ fontSize: "18px", fontWeight: "500" }}
                      >
                        1. DEFINITIONS
                      </h5>

                      <h6
                        className="mt-3"
                        style={{ fontWeight: "400", fontSize: "16px" }}
                      >
                        1.1. Associates/Business Associates means a
                        supplier/buyer/service provider of the business owner
                        who avails of the credit line facility through the
                        CashOnTap platform.
                      </h6>

                      <h6
                        className="mt-3"
                        style={{ fontWeight: "400", fontSize: "16px" }}
                      >
                        1.2. Outstanding Amount means the total amount availed
                        by the associates from the Funder during a particular
                        calendar month, including any applicable fees as
                        communicated.
                      </h6>

                      <h5
                        className="mt-3"
                        style={{ fontSize: "18px", fontWeight: "500" }}
                      >
                        2. ROLE AND OBLIGATIONS OF THE Business Owner
                      </h5>

                      <h6
                        className="mt-3"
                        style={{ fontWeight: "400", fontSize: "16px" }}
                      >
                        2.1. The Business Owner shall be responsible for payment
                        of the total Outstanding Amount for each participating
                        Associates if they do not pay by end of the month.
                      </h6>

                      <h6
                        className="mt-3"
                        style={{ fontWeight: "400", fontSize: "16px" }}
                      >
                        2.2. The Business Owner shall remit the total
                        Outstanding Amount to the Funder on or before the 7th
                        day of each month, without delay or demur.
                      </h6>

                      <h6
                        className="mt-3"
                        style={{ fontWeight: "400", fontSize: "16px" }}
                      >
                        2.3. The Business Owner acknowledges that the
                        Associates's access to future credit line shall be
                        conditional on full repayment of the previous month's
                        Outstanding Amount. The Funder shall not extend further
                        credit to the Associates unless the repayment is made in
                        full.
                      </h6>

                      <h6
                        className="mt-3"
                        style={{ fontWeight: "400", fontSize: "16px" }}
                      >
                        2.4. In the event the Business Owner chooses to disburse
                        credit line using its own funds, instead of those of the
                        Funder, the Business Owner shall pay Ontap a fee
                        equivalent to 0.5% of every withdrawal made by each
                        Associates, as a Software-as-a-Service (SaaS) charge.
                      </h6>

                      <h5
                        className="mt-3"
                        style={{ fontSize: "18px", fontWeight: "500" }}
                      >
                        3. ROLE AND OBLIGATIONS OF THE FUNDER
                      </h5>

                      <h6
                        className="mt-3"
                        style={{ fontWeight: "400", fontSize: "16px" }}
                      >
                        3.1. The Funder shall extend credit lines to Associatess
                        in accordance with applicable agreements, based on
                        Business Owner confirmation and platform data.
                      </h6>

                      <h6
                        className="mt-3"
                        style={{ fontWeight: "400", fontSize: "16px" }}
                      >
                        3.2. Upon receipt of the monthly Outstanding Amount from
                        the Business Owner, the Funder shall reinstate the
                        credit limit for each Associates for the next month.
                      </h6>

                      <h5
                        className="mt-3"
                        style={{ fontSize: "18px", fontWeight: "500" }}
                      >
                        4. ROLE AND OBLIGATIONS OF ONTAP
                      </h5>

                      <h6
                        className="mt-3"
                        style={{ fontWeight: "400", fontSize: "16px" }}
                      >
                        4.1. Ontap shall operate and maintain the CashOnTap
                        platform to facilitate Associates onboarding, salary
                        advance tracking, and reporting.
                      </h6>

                      <h6
                        className="mt-3"
                        style={{ fontWeight: "400", fontSize: "16px" }}
                      >
                        4.2. Ontap shall provide the Business Owner with a
                        secure online workspace to upload Associates salary and
                        payroll-related data, unless an API-based integration
                        has been implemented between the Business Owner's
                        systems and Ontap. The workspace shall also enable the
                        Business Owner to access real-time dashboards reflecting
                        Associates-level usage, disbursals, and outstanding
                        balances.
                      </h6>

                      <h6
                        className="mt-3"
                        style={{ fontWeight: "400", fontSize: "16px" }}
                      >
                        4.3. In case of Business Owner-funded advances, Ontap
                        shall raise monthly invoices for the applicable 0.5%
                        SaaS fee.
                      </h6>

                      <h5
                        className="mt-3"
                        style={{ fontSize: "18px", fontWeight: "500" }}
                      >
                        5. TERM AND TERMINATION
                      </h5>

                      <h6
                        className="mt-3"
                        style={{ fontWeight: "400", fontSize: "16px" }}
                      >
                        5.1. This Agreement shall remain in force unless
                        terminated by mutual consent or with a prior written
                        notice of 30 days by any Party.
                      </h6>

                      <h6
                        className="mt-3"
                        style={{ fontWeight: "400", fontSize: "16px" }}
                      >
                        5.2. Termination shall not affect any liabilities or
                        obligations accrued prior to the date of termination.
                      </h6>

                      <h5
                        className="mt-3"
                        style={{ fontSize: "18px", fontWeight: "500" }}
                      >
                        6. MISCELLANEOUS
                      </h5>

                      <h6
                        className="mt-3"
                        style={{ fontWeight: "400", fontSize: "16px" }}
                      >
                        6.1. Governing Law & Jurisdiction: This Agreement shall
                        be governed by and construed in accordance with the laws
                        of India. The courts of New Delhi shall have exclusive
                        jurisdiction.
                      </h6>

                      <h6
                        className="mt-3"
                        style={{ fontWeight: "400", fontSize: "16px" }}
                      >
                        6.2. Amendments: Any amendment to this Agreement shall
                        be made in writing and duly signed by all Parties.
                      </h6>

                      <h6
                        className="mt-3"
                        style={{ fontWeight: "400", fontSize: "16px" }}
                      >
                        6.3. Entire Agreement: This Agreement constitutes the
                        entire understanding among the Parties and supersedes
                        all prior understandings, whether oral or written.
                      </h6>

                      <h6
                        className="mt-3"
                        style={{ fontWeight: "400", fontSize: "16px" }}
                      >
                        6.4. Counterparts: This Agreement may be executed in
                        counterparts, each of which shall be deemed an original,
                        and all of which together shall constitute one and the
                        same instrument.
                      </h6>

                      <h6
                        className="mt-3"
                        style={{ fontWeight: "600", fontSize: "18px" }}
                      >
                        IN WITNESS WHEREOF, the Parties hereto have caused this
                        Agreement to be executed by their duly authorized
                        representatives as of the date first above written.
                      </h6>

                      <h6
                        className="mt-5"
                        style={{ fontWeight: "400", fontSize: "16px" }}
                      >
                        For Ontap Technologies Pvt. Limited
                      </h6>
                      <h6 style={{ fontWeight: "400", fontSize: "16px" }}>
                        (Signature)
                      </h6>
                      <h6 style={{ fontWeight: "400", fontSize: "16px" }}>
                        Name:
                      </h6>
                      <h6 style={{ fontWeight: "400", fontSize: "16px" }}>
                        Designation:
                      </h6>

                      <h6
                        className="mt-3"
                        style={{ fontWeight: "400", fontSize: "16px" }}
                      >
                        For Business Owner
                      </h6>
                      <h6 style={{ fontWeight: "400", fontSize: "16px" }}>
                        (Signature)
                      </h6>
                      <h6 style={{ fontWeight: "400", fontSize: "16px" }}>
                        Name:
                      </h6>
                      <h6 style={{ fontWeight: "400", fontSize: "16px" }}>
                        Designation:
                      </h6>

                      <h6
                        className="mt-3"
                        style={{ fontWeight: "400", fontSize: "16px" }}
                      >
                        For Capital Trust Limited
                      </h6>
                      <h6 style={{ fontWeight: "400", fontSize: "16px" }}>
                        (Signature)
                      </h6>
                      <h6 style={{ fontWeight: "400", fontSize: "16px" }}>
                        Name:
                      </h6>
                      <h6 style={{ fontWeight: "400", fontSize: "16px" }}>
                        Designation:
                      </h6>
                    </div>
                  </Modal.Body>
                  {!workSpace?.assuranceTc ? (
                    !showOtp ? (
                      <Modal.Footer className="d-flex justify-content-between">
                        <>
                          <div className="pl-3">
                            <input
                              type="checkbox"
                              checked={isChecked}
                              onChange={handleCheckboxChange}
                              style={{
                                width: "20px",
                                height: "20px",
                                padding: "10px",
                                boxSizing: "border-box",
                                border: "1px solid #ccc",
                                borderRadius: "4px",
                                fontSize: "18px",
                              }}
                            />
                          </div>
                          <div className="d-flex justify-content-end pr-3">
                            <button
                              className="btn btn-secondary"
                              style={{ width: "100px" }}
                              onClick={handleClose}
                            >
                              Back
                            </button>
                            <button
                              className="btn btn-success ml-2"
                              style={{
                                width: "100px",
                                background: "#66a725",
                              }}
                              onClick={() => handleSubmit()}
                            >
                              Proceed
                            </button>
                          </div>
                        </>
                      </Modal.Footer>
                    ) : (
                      <Modal.Footer className="d-flex justify-content-center">
                        <Formik
                          initialValues={{ email: "" }}
                          // validationSchema={LoginSchema}
                          onSubmit={(values) => {
                            const hasEmptyString = otp.some(
                              (value) => value === ""
                            );
                            if (!hasEmptyString) {
                              const data = {
                                emailid: workSpace?.email,
                                otp: parseInt(otp.join("")),
                                deviceid: deviceID,
                                latitude: location?.latitude,
                                longitude: location?.longitude,
                                address: address,
                              };
                              let config = {
                                method: "post",
                                maxBodyLength: Infinity,
                                url: `${APIURL}/verifyOtp`,
                                headers: {
                                  "Content-Type": "application/json",
                                  Cookie:
                                    "JSESSIONID=BC3EE2C6CF6BEC78620E768072A47123",
                                },
                                data: data,
                              };

                              setIsLoading(true);
                              axios
                                .request(config)
                                .then((response) => {
                                  console.log("response", response);
                                  toast.success(response?.data);
                                  setIsLoading(false);
                                  handleClose();
                                  setTncSign(true);
                                  // window.location.reload();
                                })
                                .catch((error) => {
                                  console.log("error", error);
                                  setIsLoading(false);
                                  toast.warning("Invalid...");
                                });
                            } else {
                              toast.error("All fields required");
                            }
                          }}
                        >
                          {({ touched, errors }) => (
                            <>
                              <Form className=" ">
                                <div>
                                  <div>
                                    <div className="mt-2">
                                      <p
                                        style={{
                                          display: "flex",
                                          justifyContent: "start",
                                          fontSize: "16px",
                                          fontWeight: "500",
                                        }}
                                        className=""
                                      >
                                        Enter OTP*
                                      </p>
                                    </div>
                                    <div className="row mt-2">
                                      <div className="col-lg-12 text-center">
                                        <div
                                          className=""
                                          style={{
                                            flexDirection: "row",
                                            columnGap: "10px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "start",
                                          }}
                                        >
                                          {otp.map((digit, index) => (
                                            <input
                                              key={index}
                                              value={digit}
                                              maxLength={1}
                                              onChange={(e) =>
                                                handleChange(
                                                  e.target.value,
                                                  index
                                                )
                                              }
                                              onKeyUp={(e) =>
                                                handleBackspaceAndEnter(
                                                  e,
                                                  index
                                                )
                                              }
                                              ref={(reference) =>
                                                (otpBoxReference.current[
                                                  index
                                                ] = reference)
                                              }
                                              style={{
                                                height: "45px",
                                                width: "45px",
                                              }}
                                              className={`border w-12 h-12 text-4xl text-black p-3 rounded-md block bg-light focus:border-2 focus:outline-none appearance-none text-center`}
                                            />
                                          ))}
                                        </div>
                                      </div>
                                    </div>
                                    <div className="d-flex justify-content-between">
                                      <button
                                        className="btn btn-success mt-3"
                                        type="submit"
                                        style={{
                                          background: "#66a725",
                                          color: "#fff",
                                        }}
                                      >
                                        {isLoading ? (
                                          <div
                                            className="spinner-border text-success"
                                            role="status"
                                          >
                                            <span className="sr-only">
                                              Loading...
                                            </span>
                                          </div>
                                        ) : (
                                          "Submit"
                                        )}
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </Form>
                            </>
                          )}
                        </Formik>
                      </Modal.Footer>
                    )
                  ) : (
                    ""
                  )}
                </Modal>
              </div>
            </>
          )}
        </div>
      ) : (
        <>
          <ManageEmploye />
        </>
      )}
    </>
  );
}

export default Profile;
